import type { ProspectMatterType } from '@common/enums';
import { getMatterTypeLabel } from '@common/util';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MatterTypeIcon from './MatterTypeIcon';

interface SelectionCardProps {
    matterType: ProspectMatterType;
    isActive?: boolean;
    disabled?: boolean;
    maxWidth?: string;
    onClick?(): void;
}

export default function SelectionCard({
    matterType,
    isActive = false,
    disabled = false,
    maxWidth = '100%',
    onClick,
}: SelectionCardProps) {
    const theme = useTheme();
    const label = getMatterTypeLabel(matterType);

    return (
        <Box
            role="button"
            onClick={!disabled ? onClick : undefined}
            sx={{
                display: 'flex',
                flex: '1 1',
                minWidth: 200,
                maxWidth,
                height: '88px',
                color: '#000',
                backgroundColor: isActive ? theme.palette.primary.P_100 : '#ffffff',
                border: '1px solid #C5C8CC',
                borderRadius: '4px',
                transition: 'width 0.2s ease-in',
                boxSizing: 'border-box',
                padding: '0 24px',
                alignItems: 'center',
                justifyContent: 'space-between',
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                cursor: disabled ? 'default' : 'pointer',
            }}
        >
            <Typography fontSize="16px" fontWeight="500">
                {label}
            </Typography>
            <MatterTypeIcon matterType={matterType} width={40} color="#7FAAE6" />
        </Box>
    );
}
